import { HStack, Pressable, Text } from 'native-base';
import { Icon } from '../../Common/components/Icon';
import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export type DoctorHeaderProps = {
  title: string;
  icon: IconProp;
  isAlert?: boolean;
  onClickNew?: () => void;
};

export function DoctorHeader({ title, icon, onClickNew, isAlert = false }: DoctorHeaderProps) {
  const bgColor = isAlert ? 'red.600' : 'gray.100';
  const textColor = isAlert ? 'white' : 'black';
  const linkText = isAlert ? '+ Manage' : '+ New';
  return (
    <HStack bg={bgColor} px={2} space={1} alignItems={'center'} borderRadius={'sm'} mb={2}>
      <Icon color={textColor} icon={icon} />

      <Text p={2} flex={1} fontWeight={600} fontSize={'md'} color={textColor}>
        {title}
      </Text>

      {onClickNew && (
        <Pressable onPress={onClickNew}>
          <Text color={textColor}>{linkText}</Text>
        </Pressable>
      )}
    </HStack>
  );
}
